import * as React from 'react'
import { CSSProperties } from 'react'
import useGame from './stores/useGame.jsx'

interface LoaderOptions {
  containerStyles: CSSProperties
  innerStyles: CSSProperties
  barStyles: CSSProperties
  dataStyles: CSSProperties
}

export function DSLloader({
  containerStyles,
  innerStyles,
  barStyles,
  dataStyles,
}: Partial<LoaderOptions>) {
  const modelReady = useGame((state) => state.modelReady)

  // Start visible, fade out and unmount once model is ready
  const [shown, setShown] = React.useState(true)
  const [opacity, setOpacity] = React.useState(1)

  React.useEffect(() => {
    if (!modelReady) return
    // Fade out
    setOpacity(0)
    // Unmount after fade completes
    const t = window.setTimeout(() => setShown(false), 1500)
    return () => window.clearTimeout(t)
  }, [modelReady])

  if (!shown) return null

  return (
    <div style={{ ...styles.container, opacity, ...(containerStyles || {}) }}>
      <div>
        <div style={styles.image}>
          <div style={{ textAlign: 'center' }}>
            <img src="/graphics/the-lee-co-full-white.svg" style={{ width: '128px' }} />
          </div>
        </div>
        <div style={{ ...styles.inner, ...(innerStyles || {}) }}>
          <div style={{ ...styles.bar, ...(barStyles || {}) }} />
          <span style={{ ...styles.data, ...(dataStyles || {}) }}>LOADING</span>
        </div>
      </div>
    </div>
  )
}

const styles: { [key: string]: CSSProperties } = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#001837',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 1000ms ease',
    zIndex: 99999,
  },
  inner: {
    marginTop: '0.8em',
    width: 256,
    height: 4,
    background: '#53595f',
    textAlign: 'center',
  },
  bar: {
    height: 4,
    width: '100%',
    background: '#ed1b30',
    transformOrigin: 'left center',
    animation: 'dsl-loading-pulse 1.5s ease-in-out infinite',
  },
  data: {
    display: 'inline-block',
    position: 'relative',
    fontVariantNumeric: 'tabular-nums',
    marginTop: '0.8em',
    color: '#f0f0f0',
    fontSize: '1em',
    fontFamily: `"Roboto", serif`,
    whiteSpace: 'nowrap',
    letterSpacing: '0.15em',
  },
  image: {
    margin: 'auto',
    display: 'block',
  },
}
